// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"79fe9e0d","455":"500dd8f9"}[chunkId] + ".chunk.js";
};